export default __webpack_public_path__ + "static/media/checkbox-checked-icon.03242421.svg";